import axios from "axios";
import routes from "../app/routes";

const prepareFormDataForSend = (enterpriseId, values) => {
  let formData = {
    title: values.title,
    enterprise_id: enterpriseId,
  };
  return formData;
};

export const teamActions = {
  loadTeams: (enterpriseId, dispatch) => {
    axios
      .get(routes.api.teams.index, {
        params: {
          q: {
            enterprise_id_eq: enterpriseId,
          },
        },
      })
      .then((resp) => {
        dispatch({ type: "loadTeams", teams: resp.data.data });
      });
  },
  editTeam: (enterpriseId, teamId) => {
    document.location.href = routes.api.teams.edit(enterpriseId, teamId);
  },
  removeTeam: (dispatch, row, callback) => {
    axios.delete(routes.api.teams.destroy(row.id)).then((resp) => {
      dispatch({ type: "removeTeam", teamId: row.id });
    });
  },
  addTeam: (dispatch, enterpriseId, values, callback) => {
    axios
      .post(routes.api.teams.create, {
        ...prepareFormDataForSend(enterpriseId, values),
      })
      .then((resp) => {
        callback();
      });
  },
};
